import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '../store';
import SendCollectionRecognizeDialog from '../components/SendCollectionRecognizeDialog';

export default function showSendCollectionRecognizeDialog(props) {
  const $wrapper = document.createElement('div');
  $wrapper.classList.add('wrapperDialog');
  $wrapper.classList.add('wrapperMoveDialog');
  document.body.appendChild($wrapper);
  const root = createRoot($wrapper);

  function destroy() {
    root.unmount();
    document.body.removeChild($wrapper);
  }

  root.render(
    <Provider store={store}>
      <SendCollectionRecognizeDialog destroy={destroy} {...props} />
    </Provider>,
  );
}
